import { Client } from 'urql';
import { propertyPageQuery } from './propertyPageQuery';

export const fetchPropertyPage = async ({
  client,
  slug,
  propertyId,
  toggleShowAVMData,
  toggleShowOriginNbnBrick,
  toggleMainImageDataMigration,
  togglePropertyReport,
  toggleBYBLegalDisclaimers,
  togglePcaChat,
}: {
  client: Client;
  slug: string;
  propertyId: string;
  toggleShowAVMData: boolean;
  toggleShowOriginNbnBrick: boolean;
  toggleMainImageDataMigration: boolean;
  togglePropertyReport: boolean;
  toggleBYBLegalDisclaimers: boolean;
  togglePcaChat: boolean;
}) => {
  const { data, error } = await client
    .query(propertyPageQuery, {
      slug,
      id: propertyId,
      toggleShowAVMData,
      toggleShowOriginNbnBrick,
      toggleMainImageDataMigration,
      togglePropertyReport,
      toggleBYBLegalDisclaimers,
      togglePcaChat,
    })
    .toPromise();
  return { data, error };
};
